import React, { useEffect, useRef, useState } from "react";
import { CgPushChevronRight } from "react-icons/cg";

// import MapChart from "./Map/map"
import {
  alpha,
  Autocomplete,
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  Menu,
  MenuItem,
  Modal,
  styled,
  TextField,
  Theme,
  Typography,
  CSSObject,
  Input,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { serviceConfig } from "../core/service";
import customerpresence from "../../../assets/Images/Component 5.png";
import sales from "../../../assets/Images/lists.png";
import marketing from "../../../assets/Images/contact1.png";
import customersuccess from "../../../assets/Images/task.png";
import contacts from "../../../assets/Images/contact2.png";
import highlights from "../../../assets/Images/Component 6.png";
import NorthIcon from "@mui/icons-material/North";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import { fontSize } from '@mui/system';
// import LineChart from '../../../../assets/images/line.png'
//import Map from '../../../../assets/images/map.png';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Searchimg from "../../../assets/Images/Search.png";
import "./Dashboard.scss";
// import SearchIcon from '@mui/icons-material/Search';
// import shareiconimg from '../../../../assets/images/share_icon.png'
import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import CancelIcon from "@mui/icons-material/Cancel";
import { createTheme, ThemeProvider } from "@mui/material";
import { KPISearch } from "./kpi_search/Kpisearch";
//  import trend from '../../../assets/Images/11.jpg'
import { MdCheckCircle, MdRadioButtonUnchecked } from "react-icons/md";
import "./Map/map.css";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import MuiDrawer from "@mui/material/Drawer";
import Swal from "sweetalert2";
import axios from "axios";

import {fetchResearcherDetails, fetchResearcherDetailId} from '../../../api/index';
import {fetchListsDetails, fetchReminderDetails} from '../../../api/index';
import {fetchCombinedUserData} from '../../../api/userApi';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import MapContainer from "./Map/MapContainer";
import { useNavigate } from "react-router-dom";
import SidebarFilter from "../../Companies/SidebarFilter";
import { useResearcher } from "../../../context/ResearcherContext";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const Dashboard = () => {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  const yAxisLabel = ["1$", "2$", "3$", "4$"];
  const salesoptions = {
    responsive: true,
    bezierCurve: true,

    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },

      x: {
        ticks: {
          display: false,
        },
        gridLines: {
          display: false,
        },
      },
      y: {
        ticks: {
          display: false,
          beginAtZero: true,
        },
        label: {
          display: true,
          text: "Custom Y-Axis Label",
          font: {
            weight: "bold",
          },
        },
        gridLines: {
          display: false,
        },
      },
    },
  };
  const divRef = useRef(null);
  // const [isModalOpen, setIsModalOpen] = useState(false); // State variable for modal visibility
  const [activeSlide, setActiveSlide] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [salesSearchValue, setSalesSearchValue] = useState("");
  const [marketingSearchValue, setMarketingSearchValue] = useState("");
  const [successSearchValue, setSuccessSearchValue] = useState("");
  const [searchValues, setSearchValues] = useState(["", "", ""]);
  const [max, setmax] = useState(true);
  const [data, setData] = useState([]);
  const handleSearchChange = (index, value) => {
    setSearchValues((prevSearchValues) => {
      const newSearchValues = [...prevSearchValues];
      newSearchValues[index] = value;
      return newSearchValues;
    });
  };
  const searchUser = () => {
    // setLoading(true)
    // loadKpi(searchData);
  };
  const handleSlideChange = (index) => {
    setActiveSlide(index);
  };
  // const handleOpenModal = () => {
  //   setIsModalOpen(true);
  // };

  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  // };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  const { researcherId} = useResearcher();
  
  const fetchResearcher = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.error("No token found. User is not authenticated.");
    return;
  }
  const skip = 0
  const limit = 50;

  try {
   const response = await fetchResearcherDetails(researcherId, skip, limit);

      if (response.status === 204 || response.status === 404) {
        console.log(`No admin data found (status ${response.status})`);
        return;
      }

      //Show error only for real server issues
      if (!response.ok && response.status >= 500) {
        throw new Error(`Server error (${response.status})`);
      }

    const firstAdmin = response?.researcherData ?? null;

    if (firstAdmin?.details && Array.isArray(firstAdmin.details)) {

      setData(firstAdmin.details);
        const sortedAndSliced = firstAdmin.details
            .slice(0, 6);
      setUserData(sortedAndSliced);
    } else {
      setUserData([]);
    }
  } catch (error) {
    console.error("Fetch error:", error);
    setUserData([]);
  }
};

 useEffect(() => {
  if(researcherId){
    fetchResearcher();
  }
  }, [researcherId]);

  const buble_data = {
    datasets: [
      {
        label: "Red dataset",
        data: Array.from({ length: 50 }, () => ({
          x: [12, 23, 45, -45, 65, 98],
          y: [35, 56, 78, -23, 94, 44],
          r: [12, 100, 49, -12, 44, 87],
        })),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Blue dataset",
        data: Array.from({ length: 50 }, () => ({
          x: [12, 23, 45, -45, 65, 98],
          y: [12, 23, 45, -45, 65, 98],
          r: [12, 23, 45, -45, 65, 98],
        })),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  const bubble_options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const newRow = [
    {
      categroy: "My List",
      KpiName: "Sales Growth",
      value: "-69",
    },
    {
      categroy: "Marketin",
      KpiName: "Sales Growth",
      value: "+23.10",
    },
    {
      categroy: "customer_success",
      KpiName: "Projected pipeline sales value",
      value: "-69",
    },
    {
      categroy: "sales",
      KpiName: "Sales Growth",
      value: "-69",
    },
  ];

  const StyledContainer = styled(Box)`
    display: flex;
    justify-content: space-between;
  `;

  const StyledTypography1 = styled(Typography)`
    height: 20px;
    width: 60px;
    padding: 5px;
    color: black;
    font-size: 16px;
    margin-top: -2em;
    margin-left: 30em;
  `;

  const StyledTypography2 = styled(Typography)`
    height: 20px;
    width: 80px;
    padding: 5px;
    color: black;
    font-size: 16px;
    margin-top: -2em;
    margin-left: 1em;
  `;

  const [showGenerateReportText, setShowGenerateReportText] = useState(true);
  const [isGenerateDropdownVisibleSales, setIsGenerateDropdownVisibleSales] =
    useState(false);
  const [isGenerateDropdownVisibleMarket, setIsGenerateDropdownVisibleMarket] =
    useState(false);
  const [
    isGenerateDropdownVisibleCustomer,
    setIsGenerateDropdownVisibleCustomer,
  ] = useState(false);

  function handleThreeDotsClickSales() {
    setIsGenerateDropdownVisibleSales(!isGenerateDropdownVisibleSales);
    setIsGenerateDropdownVisibleMarket(false);
    setIsGenerateDropdownVisibleCustomer(false);
    setShowSecondDialog(false);
  }
  function handleThreeDotsClickMarket() {
    setIsGenerateDropdownVisibleMarket(!isGenerateDropdownVisibleMarket);
    setIsGenerateDropdownVisibleSales(false);
    setIsGenerateDropdownVisibleCustomer(false);
    setShowSecondDialog(false);
  }
  function handleThreeDotsClickCustomer() {
    setIsGenerateDropdownVisibleCustomer(!isGenerateDropdownVisibleCustomer);
    setIsGenerateDropdownVisibleMarket(false);
    setIsGenerateDropdownVisibleSales(false);
    setShowSecondDialog(false);
  }

  const [error, setError] = useState(false);
  const autocompleteRef = useRef(null);
  const [salesArray, setSalesArray] = useState([]);
  const [marketArray, setMarketArray] = useState([]);
  const [customerArray, setCustomerArray] = useState([]);
  const [salesKPI, setSalesKPI] = useState([]);
  const [marketingKPI, setMarketingKPI] = useState([]);
  const [customerSuccessKPI, setCustomerSuccessKPI] = useState([]);
  const [selectedSales, setSelectedSales] = useState("");
  const [selectedMarketing, setSelectedMarketing] = useState("");
  const [selectedCustomerSuccess, setSelectedCustomerSuccess] = useState("");
  const [selectedSalesValue, setSelectedSalesValue] = useState(
    (Math.random() * (100 - 0) + 1).toFixed(2)
  );
  const [selectedMarketingValue, setSelectedMarketingValue] = useState(
    (Math.random() * (100 - 0) + 1).toFixed(2)
  );
  const [selectedCustomerSuccessValue, setSelectedCustomerSuccessValue] =
    useState((Math.random() * (100 - 0) + 1).toFixed(2));
  // const [salereportname, setSaleReportname] = useState('')
  // const [salekpivalue, setSaleKpivalue] = useState('')
  const [salekpiname, setSaleKpiname] = useState("");
  // const [marketreportname, setMarketReportname] = useState('')
  // const [marketkpivalue, setMarketKpivalue] = useState('')
  const [marketkpiname, setMarketKpiname] = useState("");
  // const [customerreportname, setCustomerReportname] = useState('')
  // const [customerkpivalue, setCustomerKpivalue] = useState('')
  const [customerkpiname, setCustomerKpiname] = useState("");
  const [modelSale, setModelSale] = React.useState(false);
  const [modelMarket, setModelMarket] = React.useState(false);
  const [modelCustomer, setModelCustomer] = React.useState(false);
  const [showSecondDialog, setShowSecondDialog] = useState(false);
  const [showMailDialog, setShowMailDialog] = useState(false);
  const [DialogOpenSales, setDialogOpenSales] = useState(false);
  const [DialogOpenSalesF, setDialogOpenSalesF] = useState(false);
  const [DialogOpenMarket, setDialogOpenMarket] = useState(false);
  const [DialogOpenMarketF, setDialogOpenMarketF] = useState(false);
  const [DialogOpenCustomer, setDialogOpenCustomer] = useState(false);
  const [DialogOpenCustomerF, setDialogOpenCustomerF] = useState(false);
  const [salesmail, setSalesMail] = useState([]);
  // const [saleselectedReportNo, setSaleSelectedReportNo] = useState(null);
  const [saleselectedReportId, setSaleSelectedReportId] = useState(null);
  const [saleselectedReportNumber, setSaleSelectedReportNumber] =
    useState(null);
  const [saleselectedReportName, setSaleSelectedReportName] = useState("");
  const [saleselectedReportDate, setSaleSelectedReportDate] = useState("");
  const [saleselectedKpiName, setSaleSelectedKpiName] = useState("");
  const [saleselectedKpiValue, setSaleSelectedKpiValue] = useState("");
  // const [reportDetails, setReportDetails] = useState([]);
  const [marketmail, setMarketMail] = useState([]);
  // const [marketselectedReportNo, setMarketSelectedReportNo] = useState(null);
  const [marketselectedReportId, setMarketSelectedReportId] = useState(null);
  const [marketselectedReportNumber, setMarketSelectedReportNumber] =
    useState(null);
  const [marketselectedReportName, setMarketSelectedReportName] = useState("");
  const [marketselectedReportDate, setMarketSelectedReportDate] = useState("");
  const [marketselectedKpiName, setMarketSelectedKpiName] = useState(null);
  const [marketselectedKpiValue, setMarketSelectedKpiValue] = useState("");
  const [customermail, setCustomermail] = useState([]);
  // const [customerselectedReportNo, setCustomerSelectedReportNo] = useState(null);
  const [customerselectedReportId, setCustomerSelectedReportId] =
    useState(null);
  const [customerselectedReportNumber, setCustomerSelectedReportNumber] =
    useState(null);
  const [customerselectedReportName, setCustomerSelectedReportName] =
    useState("");
  const [customerselectedReportDate, setCustomerSelectedReportDate] =
    useState("");
  const [customerselectedKpiName, setCustomerSelectedKpiName] = useState("");
  const [customerselectedKpiValue, setCustomerSelectedKpiValue] = useState("");
  const [users, setUsers] = useState([]);
  const containerRef = useRef(null);

  const [list, setList] = useState([]);
  // const[selectedList,setSelectedList] = useState([])
  const [note, setNote] = useState([]);
  const [reminders, setReminders] = useState([]);
  const sortedReminders = [...reminders].sort(
    (a, b) => new Date(b.time) - new Date(a.time)
  );
  const latestReminder = sortedReminders[0];
  const [lastList, setLastList] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [id, setId] = useState("");
  const [userData, setUserData] = useState([]);
  const [myContactData, setMyContactData] = useState(0);
  const navigate = useNavigate();
  const [viewType, setViewType] = useState("lists");
  const viewTypes = ["lists", "My Contacts", "task"];
  const [latestCompanyName, setLatestCompanyName] = useState("");

  const [userDataCount, setUserDataCount] = useState(0);

  const [latestcompletedReminder, setLatestCompletedReminder] = useState("");

  useEffect(() => {
    fetchLists();
  }, []);

  const fetchLists = async () => {
    try {
      const data = await fetchListsDetails();
      if (data.lists?.length) {
        const validatedLists = data.lists.map((list) => ({
          _id: list._id || new Date().getTime(),
          listName: list.listName,
          userCount: list.users.length,
        }));

        setList(validatedLists);
        setLastList(validatedLists[validatedLists.length - 1]);
      } else {
        console.warn("No lists found");
      }
    } catch (error) {
      console.error("Error fetching lists:", error);
    }
  };

  useEffect(() => {
    const fetchAllReminders = async () => {

      try {
        const data = await fetchReminderDetails();

        const allReminders = data.reminders || [];
        setReminders(allReminders);

        // Find latest completed reminder
        const completedReminders = allReminders?.filter(
          (reminder) => reminder.completedAt
        );
        const latest = completedReminders?.sort(
          (a, b) => new Date(b.completedAt) - new Date(a.completedAt)
        )[0];

        if (latest) {
          setLatestCompletedReminder(latest);

          // Find matching user from already-fetched userData
          const user = userData.find((u) => u._id === latest.detailId);
          if (user) {
            setLatestCompanyName(`${user.companyname || "N/A"}`);
          }
        }
      } catch (error) {
        console.error("Error fetching all reminders:", error);
      }
    };

    fetchAllReminders();
  }, [userData]);

  useEffect(() => {
    const fetchDashboardUsers = async () => {
      const skip = 10;
      const limit = 50

      try {
        const data = await fetchCombinedUserData(skip, limit, researcherId);
        if (data) {
          setUserDataCount(data.totalCount);
        } else {
          console.error("'details' is missing or not an array");
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error.message);
      }
    };

    fetchDashboardUsers();
  }, []);


  const handleOrgActionSale = () => {
    setModelSale(true);
    setShowSecondDialog(false);
  };
  const handleOrgActionMarket = () => {
    setModelMarket(true);
    setShowSecondDialog(false);
  };
  const handleOrgActionCustomer = () => {
    setModelCustomer(true);
    setShowSecondDialog(false);
  };
 const [isUserTouching, setIsUserTouching] = useState(false);
const handleTouchStart = () => {
  setIsUserTouching(true);
};
const handleTouchEnd = () => {
  setIsUserTouching(false);
};

useEffect(() => {
  const tableContainer = divRef.current;
  let scrollInterval = null;
  let reach = "top";

  const startAutoScroll = () => {
    scrollInterval = setInterval(() => {
      if (
        tableContainer.scrollTop + tableContainer.clientHeight >=
        tableContainer.scrollHeight
      ) {
        reach = "bottom";
      } else if (tableContainer.scrollTop === 0) {
        reach = "top";
      }

      tableContainer.scrollTop =
        reach === "top"
          ? tableContainer.scrollTop + 1
          : tableContainer.scrollTop - 1;
    }, 50);
  };

  const stopAutoScroll = () => {
    clearInterval(scrollInterval);
  };

  if (!isUserTouching) {
    startAutoScroll();
    tableContainer.style.cursor = "default";
  } else {
    stopAutoScroll();
    tableContainer.style.cursor = "pointer";
  }

  return () => {
    stopAutoScroll();
    tableContainer.style.cursor = "default";
  };
}, [isUserTouching]);

  
  const [saleData, setSaleData] = useState([]);
  const salesKpidata = async (search_data) => {
    let query = {
      by_page: true,
      category: "sales",
    };
    if (search_data) {
      query["name"] = search_data;
    }
    serviceConfig.get("kpi_list", true, query, null).then(
      (data) => {
        setSaleData(data.results[0].kpi_name);
      },
      (err) => {
        console.log(err);
      }
    );
  };
  const [marketingDate, setMarketingdate] = useState([]);
  
  const [customerData, setCustomerdata] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const theme = createTheme({
    palette: {
      primary: {
        main: "#FCB124",
      },
    },
  });
  // search option
  const [searchopen, setSearchopen] = useState(false);
  const handlesearch = () => {
    setSearchopen(!searchopen);
  };
  const [salessearchopen, setSalessearchopen] = useState(false);
  const handlesalessearch = (index) => {
    setSelectedIndex(index);
    // setSelectedArray(data);
    setSalessearchopen(!salessearchopen);
  };
  const [marketingsearchopen, setMarketingsearchopen] = useState(false);
  const handlemarketingsearch = () => {
    setMarketingsearchopen(!marketingsearchopen);
  };
  const [successsearchopen, setsuccesssearchopen] = useState(false);
  const handlesuccesssearch = () => {
    setsuccesssearchopen(!successsearchopen);
  };
  const [kpisearchopen, setKpisearchopen] = useState(false);
  const handlekpisearch = () => {
    setKpisearchopen(!kpisearchopen);
  };
  const handleGenerateSaleUsers = () => {
    setShowMailDialog(true);
    serviceConfig.get("user", true, { users: "users" }, null).then(
      (data) => {
        console.log(data);

        data.map((item) => {
          salesmail.push(item.email);
          console.log(salesmail);
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const handleGenerateMarketUsers = () => {
    setShowMailDialog(true);
    serviceConfig.get("user", true, { users: "users" }, null).then(
      (data) => {
        console.log(data);
        data.map((item) => {
          marketmail.push(item.email);
          console.log(marketmail);
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };
  const handleGenerateCustomerUsers = () => {
    setShowMailDialog(true);
    serviceConfig.get("user", true, { users: "users" }, null).then(
      (data) => {
        console.log(data);
        data.map((item) => {
          customermail.push(item.email);
          console.log(customermail);
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    borderRadius: "20px",
    backgroundColor: " #F0F3F6",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(1)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "20ch",
      },
    },
  }));

  const StyledInputBase2 = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    borderRadius: "20px",
    backgroundColor: " #F0F3F6",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(1)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "11ch",
      },
    },
  }));

  const handleClearAutocomplete = () => {
    setUsers("");
    if (autocompleteRef.current) {
      autocompleteRef.current.focus();
    }
  };

  const handleGenerateSalesMail = () => {
    if (salesmail.includes(users)) {
      console.log(users);
      serviceConfig
        .get(
          "mail_report",
          true,
          { id: saleselectedReportId, email: users },
          null
        )
        .then((data) => {
          setDialogOpenSales(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log("User mail not found.");
      setDialogOpenSalesF(true);

      return;
    }
    setShowMailDialog(false);
  };
  const handleGenerateMarketMail = () => {
    if (marketmail.includes(users)) {
      console.log(users);
      serviceConfig
        .get(
          "mail_report",
          true,
          { id: marketselectedReportId, email: users },
          null
        )
        .then((data) => {
          setDialogOpenMarket(true);
          // setShowMailDialog(false)
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log("User mail not found.");
      setDialogOpenMarketF(true);

      return;
    }
    setShowMailDialog(false);
  };

  const handleGenerateCustomerMail = () => {
    if (customermail.includes(users)) {
      console.log(users);
      serviceConfig
        .get(
          "mail_report",
          true,
          { id: customerselectedReportId, email: users },
          null
        )
        .then((data) => {
          setDialogOpenCustomer(true);
          // setShowMailDialog(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log("User mail not found.");
      setDialogOpenCustomerF(true);
      return;
    }
    setShowMailDialog(false);
  };

  const handleGenerateSalesReport = () => {
    if (salekpiname.length === 0) {
      // KPI name is not provided, set the error state
      setError(true);
      setShowSecondDialog(false);
      return;
    }

    // Reset the error state if the KPI name is provided
    setError(false);
    setShowSecondDialog(true);
    //sales
    serviceConfig
      .post(
        "report_generate",
        true,
        { report_name: "sales", kpi_name: salekpiname, kpi_value: "91.02" },
        null,
        null,
        true
      )
      .then(
        (data) => {
          setSaleSelectedReportId(data.id);
          setSaleSelectedReportNumber(data.report_num);
          setSaleSelectedReportName("Sales");
          const createdAt = new Date(data.CreatedAt);
          const formattedDate = createdAt.toLocaleString();
          setSaleSelectedReportDate(formattedDate);
          setSaleSelectedKpiName(data.kpi_name);
          console.log(saleselectedKpiName);
          setSaleSelectedKpiValue("91.52");
        },
        (err) => {
          console.log(err);
        }
      );
  };

  //marketing
  const handleGenerateMarketReport = () => {
    if (marketkpiname.length === 0) {
      // KPI name is not provided, set the error state
      setError(true);
      setShowSecondDialog(false);
      return;
    }

    // Reset the error state if the KPI name is provided
    setError(false);
    setShowSecondDialog(true);
    //sales
    serviceConfig
      .post(
        "report_generate",
        true,
        {
          report_name: "marketing",
          kpi_name: marketkpiname,
          kpi_value: "91.02",
        },
        null,
        null,
        true
      )
      .then(
        (data) => {
          setMarketSelectedReportId(data.id);
          //  setMarketSelectedReportNo(data.report_no)
          setMarketSelectedReportNumber(data.report_num);
          setMarketSelectedReportName("Marketing");
          const createdAt = new Date(data.CreatedAt);
          const formattedDate = createdAt.toLocaleString();
          setMarketSelectedReportDate(formattedDate);
          setMarketSelectedKpiName(data.kpi_name);
          setMarketSelectedKpiValue("91.52");
        },
        (err) => {
          console.log(err);
        }
      );
  };

  //customer success
  const handleGenerateCustomerReport = () => {
    if (customerkpiname.length === 0) {
      // KPI name is not provided, set the error state
      setError(true);
      setShowSecondDialog(false);
      return;
    }

    // Reset the error state if the KPI name is provided
    setError(false);
    setShowSecondDialog(true);
    //customer_success
    serviceConfig
      .post(
        "report_generate",
        true,
        {
          report_name: "customer_success",
          kpi_name: customerkpiname,
          kpi_value: "91.02",
        },
        null,
        null,
        true
      )
      .then(
        (data) => {
          setCustomerSelectedReportId(data.id);
          //  setCustomerSelectedReportNo(data.report_no)
          setCustomerSelectedReportNumber(data.report_num);
          setCustomerSelectedReportName("Customer Success");
          const createdAt = new Date(data.CreatedAt);
          const formattedDate = createdAt.toLocaleString();
          setCustomerSelectedReportDate(formattedDate);
          setCustomerSelectedKpiName(data.kpi_name);
          setCustomerSelectedKpiValue("91.52");
        },
        (err) => {
          console.log(err);
        }
      );
  };

  const handleOpenContacts = () => {
    navigate("/contacts");
  };
  // popup view chart
  const [chartopen, setChartopen] = useState(false);
  const [selectedArray, setSelectedArray] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const handleOpenchart = (data, index) => {
    setViewType('lists');
    setChartopen(true);
    setSelectedArray(data);
    setSelectedIndex(index);
    // setPopupheading(SalemappindData.Name)
    setPopupname(data);
  };

    const handleOpenchartContacts = (data, index) => {
    setViewType('My Contacts');
    setChartopen(true);
    setSelectedArray(data);
    setSelectedIndex(index);
    // setPopupheading(SalemappindData.Name)
    setPopupname(data);
  };

    const handleOpenchartTask = (data, index) => {
    setViewType('task');
    setChartopen(true);
    setSelectedArray(data);
    setSelectedIndex(index);
    // setPopupheading(SalemappindData.Name)
    setPopupname(data);
  };

  const handleClosechart = () => {
    setChartopen(false);
  };

  const [popupsearchopen, setPopupsearchopen] = useState(false);
  const handlepopupsearch = () => {
    setPopupsearchopen(!popupsearchopen);
  };

  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setModelSale(true);
    setAnchorEl1(null);
  };

  const [popupname, setPopupname] = useState("");

  const cardheader = {
    Sales: "My Lists",
    Marketing: "My Contacts",
    Customersuccess: "Task",
  };

  // const contents = ['Sales', 'Marketing', 'Customer success'];
  // // console.log(contentIndex.indexof(), 'lllllllllllllllllllllllllllllllllll')
  // const currentContent = contents[contentIndex];

  const SalemappindData = [
    {
      Name: "Sales",
      category: "sales",
      Images: sales,
      TotelValue: "70.25",
      PercentageValue: "-1.5",
      kpifirstvalue: saleData,
      color: "red",
      chart_data: {
        labels,
        yAxisLabel,
        datasets: [
          {
            fill: true,
            lineTension: 0,
            Legend: false,
            data: [0, 0, 0, 2, 1.5, 1, 2.3],
            borderColor: "rgba(11, 169, 234, 1)",
            backgroundColor: "rgba(11, 169, 234, 1)",
          },
        ],
      },
    },
    {
      Name: "Marketing",
      category: "marketing",
      Images: marketing,
      TotelValue: "80.25",
      PercentageValue: "-1.5",
      kpifirstvalue: marketingDate,
      color: "yellow",
      chart_data: {
        labels,
        yAxisLabel,
        datasets: [
          {
            fill: true,

            lineTension: 0,
            Legend: false,
            data: [0, 0, 0, 2, 1.5, 1, 2.3],
            borderColor: "rgba(74, 199, 159, 1)",
            backgroundColor: "rgba(74, 199, 159, 1)",
          },
        ],
      },
    },
    {
      Name: "Customer Success",
      category: "customer_success",
      Images: customersuccess,
      TotelValue: "78.25",
      PercentageValue: "-2.5",
      kpifirstvalue: customerData,
      color: "green",
      chart_data: {
        labels,
        yAxisLabel,
        datasets: [
          {
            fill: true,
            lineTension: 0,
            Legend: false,
            data: [0, 0, 0, 2, 1.5, 1, 2.3],
            borderColor: "rgba(251, 120, 4, 1)",
            backgroundColor: "rgba(251, 120, 4, 1)",
          },
        ],
      },
    },
  ];

  // const changeTitle = (ch) => {
  //   if (ch === 'prev') {
  //     setSelectedIndex(selectedIndex - 1)
  //     setSelectedArray(SalemappindData[selectedIndex - 1])
  //   } else {
  //     setSelectedIndex(selectedIndex + 1)
  //     setSelectedArray(SalemappindData[selectedIndex + 1])
  //   }

  // }

  const toggleTaskCompletion = async (index) => {
    const updatedReminders = [...reminders];
    const reminder = updatedReminders[index];
    const newStatus = reminder.status === "pending" ? "completed" : "pending";
    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${baseURL}/api/reminders/status`,
        {
          reminderId: reminder._id,
          detailId: reminder.detailId,
          status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      updatedReminders[index] = response.data.reminder;

      if (response.data.reminder) {
        updatedReminders[index] = response.data.reminder;
        setReminders(updatedReminders);
      } else {
        console.warn("Reminder not returned in response", response.data);
      }
    } catch (error) {
      console.error("Failed to update status", error);
    }
  };

  const completedReminders = Array.isArray(reminders)
    ? reminders.filter((r) => r && r.status === "completed")
    : [];

  const latestCompletedReminder = completedReminders.sort(
    (a, b) => new Date(b.completedAt) - new Date(a.completedAt)
  )[0];

  // const latestReminder = reminders.sort((a, b) => new Date(b.time) - new Date(a.time))[0];

  const company = userData?.details?.find(
    (detail) => detail._id === latestReminder.detailId
  )?.companyname;

  const truncateWords = (text, wordLimit = 3) => {
    if (!text) return "Not Available";
    const words = text.split(/\s+/);
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

const handlePushToList = async (user) => {
  try {
    const token = localStorage.getItem('token');

    const response = await fetch(`${baseURL}/api/user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(user),
    });

    if (!response.ok) {
      throw new Error("Failed to push contact");
    }

    const result = await response.json();
    Swal.fire({
        icon: "success",
        title: "Contact pushed successfully",
        confirmButtonText: "OK",
      });
    console.log("Success:", result);
  } catch (error) {
    console.error("Error:", error);
    Swal.fire({
        icon: "error",
        title: "Push Failed",
        text: "There was a problem pushing the contact.",
        confirmButtonText: "OK",
      });
  }
};

  return (
    <>
      <Dialog
        className="viewchart-popup"
        open={chartopen}
        maxWidth="md"
        onClose={handleClosechart}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            background: "white",
            backdropFilter: "blur(12px)",
            borderRadius: "20px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            padding: "20px",
            overflow: "hidden",
            overflowY: "auto",
          },
        }}
      >
        <div
          className="viewchart-popup-container"
          style={{ position: "relative" }}
        >
          <CancelIcon
            onClick={handleClosechart}
            
            style={{
              position: "absolute",
              right: "16px",
              color: "#666",
              cursor: "pointer",
              transition: "0.3s",
            }}

            className="popup-arrow"
          />

          <div
            style={{
              padding: "15px 20px",
              height: "80vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header */}
            <div
              className="small-card-head"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "15px",
                borderBottom: "1px solid rgba(0,0,0,0.1)",
                paddingBottom: "10px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                {/* {viewType !== "lists" && (
                  <IconButton onClick={() => changeView("prev")}>
                    <KeyboardArrowLeftIcon />
                  </IconButton>
                )} */}
                {viewType === 'lists' && (
                   <img
                  src={sales}
                  alt="User"
                  style={{ width: "36px", height: "36px", borderRadius: "50%" }}
                />
                )}

               {viewType === 'My Contacts' && (
                   <img
                  src={marketing}
                  alt="User"
                  style={{ width: "36px", height: "36px", borderRadius: "50%" }}
                />
                )}
                {viewType === 'task' && (
                   <img
                  src={customersuccess}
                  alt="User"
                  style={{ width: "36px", height: "36px", borderRadius: "50%" }}
                />
                )}
                <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                  {viewType.charAt(0).toUpperCase() + viewType.slice(1)}
                </span>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                {popupsearchopen && (
                  <Search>
                    <StyledInputBase2
                      placeholder="Search here"
                      inputProps={{ "aria-label": "search" }}
                      endAdornment={
                        <InputAdornment position="end">
                          <CloseIcon
                            onClick={handlepopupsearch}
                            style={{ cursor: "pointer", color: "#999" }}
                          />
                        </InputAdornment>
                      }
                    />
                  </Search>
                )}
                {/* <IconButton
                  onClick={handleClick1}
                  aria-controls={open1 ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                >
                  <MoreVertIcon style={{ color: "#444" }} />
                </IconButton> */}
                <Menu
                  anchorEl={anchorEl1}
                  id="account-menu"
                  open={open1}
                  onClose={handleClose1}
                  onClick={handleClose1}
                  PaperProps={{
                    elevation: 3,
                    sx: {
                      borderRadius: "10px",
                      minWidth: 160,
                    },
                  }}
                >
                  <MenuItem onClick={handleClose1}>Generate Report</MenuItem>
                </Menu>
              </div>
            </div>

            {/* Body */}
            <div
              className="small-card-body"
              style={{
                flex: 1,
                padding: "10px",
                fontSize: "0.95rem",
                borderRadius: "8px",
              }}
            >
              {viewType === "lists" &&
                list?.map((item) => (
                  <>
                    <div
                      key={item._id}
                      style={{
                        padding: "12px 15px",
                        marginBottom: "10px",
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          marginBottom: "5px",
                          color: "#333",
                        }}
                        onClick={() =>
                          navigate('/my-list', {
                            state: { listName: lastList.listName, checkMyList: true }
                          })
                        }
                      >
                        {item.listName}
                      </div>
                      <div style={{ fontSize: "0.9rem", color: "#666" }}>
                        Users: {item.userCount}
                      </div>
                    </div>
                  </>
                ))}

              {viewType === "My Contacts" && (
                <p
                  onClick={() => {
                    navigate("/my-contacts");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  My Contacts {userDataCount}
                </p>
              )}

              {viewType === "task" && (
                <>
                  {reminders.map((reminder) => (
                    <div
                      key={reminder._id}
                      style={{
                        padding: "12px 15px",
                        marginBottom: "10px",
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <Typography
                        style={{ fontWeight: "bold", fontSize: "2.5vmin" }}
                      >
                        {reminder.subject}
                      </Typography>
                      <Typography
                        style={{ fontSize: "2.5vmin", color: "#666" }}
                      >
                        Status: {reminder.status}
                      </Typography>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </Dialog>

      <div
        className="outer"
        style={{
          width: "100%",
          height: "100%",
          padding: "3%",
          paddingTop: "3%",
          overflowX: "hidden",
          overflowY: "hidden",
          backgroundColor: "#FCFCFC",
        }}
      >
        <div id="container">
          {/* customer presences */}
          <Card variant="outlined" className="customer">
            <div className="small-card-head">
              <div
                style={{
                  width: "70%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: "4%",
                }}
              >
                <img
                  src={customerpresence}
                  alt="Ellipse"
                  style={{ width: "32px", height: "32px", marginRight: "10px" }}
                />
                {!searchopen ? (
                  <span
                    className="card-header-line"
                    style={{ fontWeight: "400" }}
                  >
                    {" "}
                    Customer Presence
                  </span>
                ) : null}
              </div>
              {!searchopen ? (
                <img
                  src={Searchimg}
                  onClick={handlesearch}
                  alt="search"
                  id="icons"
                  style={{
                    alignItems: "flex-end",
                    marginLeft: "12%",
                    fontSize: "2vmin",
                    height: "25px",
                    cursor: "pointer",
                  }}
                />
              ) : null}
              {searchopen ? (
                <Search>
                  <StyledInputBase
                    placeholder="Search here"
                    inputProps={{ "aria-label": "search" }}
                    endAdornment={
                      <InputAdornment position="end">
                        <CloseIcon
                          onClick={handlesearch}
                          style={{
                            marginRight: "5px",
                            cursor: "pointer",
                            color: "rgba(0, 0, 0, 0.5)",
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                </Search>
              ) : null}
              <IconButton
                onClick={handleClick}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MoreVertIcon
                  className="three-dot-icon"
                  style={{
                    fontSize: "4vmin",
                    color: "rgba(29, 4, 4, 0.57)",
                    cursor: "pointer",
                  }}
                />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    // filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              ></Menu>
            </div>
            <MapContainer />
          </Card>
          {/* sales box container */}
          <div className="desktop-view">
            <Card variant="outlined" className="small-card">
              <div className="small-card-head">
                <div className="card-header">
                  <img src={sales} alt="Ellipse" className="card-icons" />
                  {!salessearchopen ? (
                    <span
                      className="card-header-line"
                      style={{ fontWeight: "600" }}
                    >
                      {" "}
                      {cardheader.Sales}
                    </span>
                  ) : null}
                </div>
                {!salessearchopen ? (
                  <img
                    onClick={handlesalessearch}
                    alt="sales"
                    src={Searchimg}
                    id="icons"
                    style={{
                      alignItems: "flex-end",
                      marginLeft: "1%",
                      fontSize: "2vmin",
                      height: "17px",
                      cursor: "pointer",
                    }}
                  />
                ) : null}
                {salessearchopen ? (
                  // <Search className='card-search'>
                  <Input
                    placeholder="Search here"
                    inputProps={{ "aria-label": "search" }}
                    value={salesSearchValue}
                    onChange={(e) => {
                      setSalesSearchValue(e.target.value);
                      // loadCategory(e.target.value, "sales");
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <CloseIcon
                          onClick={handlesalessearch}
                          style={{
                            marginRight: "5px",
                            cursor: "pointer",
                            color: "rgba(0, 0, 0, 0.5)",
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                ) : // </Search>
                null}
                <button
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: "0.5rem",
                    cursor: "pointer",
                    marginLeft: "0.5rem",
                    fontSize: "17px",
                  }}
                  onClick={handleThreeDotsClickSales}
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>

                {isGenerateDropdownVisibleSales && (
                  <div style={{ position: "relative" }}>
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        backgroundColor: "white",
                        border: "1px solid black",
                        padding: "8px",
                        cursor: "pointer",
                        marginTop: "10px",
                        height: "15px",
                        width: "125px",
                        display: modelSale ? "none" : "block",
                      }}
                      onClick={() => handleOrgActionSale()}
                    >
                      Generate Report
                    </div>
                    {modelSale && (
                      <Dialog
                        open={modelSale}
                        onClose={() => setModelSale(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "3%",
                            width: "600px",
                            height: "300px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              marginTop: "4%",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            Generate Report
                          </p>

                          <Autocomplete
                            sx={{
                              marginTop: "5%",
                              width: "48%",
                              marginLeft: "2%",
                            }}
                            handleHomeEndKeys={false}
                            onSelect={(e) => {
                              console.log("selected");
                            }}
                            open={
                              salekpiname.length === 0 ||
                              !salesArray.includes(salekpiname)
                            }
                            openOnFocus={false}
                            autoHighlight={false}
                            autoComplete={true}
                            autoSelect={true}
                            noOptionsText={false}
                            value={salekpiname}
                            options={salesArray}
                            onInputChange={(event, value) => {
                              console.log(value);
                              if (value.startsWith(value)) {
                                serviceConfig
                                  .get(
                                    "kpi_list",
                                    true,
                                    { category: "sales", name: value },
                                    null
                                  )
                                  .then((data) => {
                                    setSalesKPI(data);
                                    const newOptions = data
                                      .filter(
                                        (item) =>
                                          item.category === "sales" &&
                                          item.kpi_name
                                            .toLowerCase()
                                            .startsWith(value.toLowerCase())
                                      )
                                      .map((item) => item.kpi_name);
                                    setSalesArray(newOptions);
                                  });
                              } else {
                                setSalesArray([]);
                              }
                              setSaleKpiname(value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Enter KPI Name"
                                variant="standard"
                              />
                            )}
                          />
                          {error && (
                            <p style={{ color: "red" }}>KPI name is required</p>
                          )}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "5%",
                              marginRight: "5%",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="cancel-button"
                              onClick={() => setModelSale(false)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              className="save-button"
                              style={{ width: "100px" }}
                              onClick={handleGenerateSalesReport}
                            >
                              Generate
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                    )}
                    <Dialog
                      open={showSecondDialog}
                      onClose={() => setShowSecondDialog(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "600px",
                          height: "400px",
                        }}
                      >
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowSecondDialog(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>

                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "4%",
                            fontWeight: "bold",
                            marginLeft: "4%",
                          }}
                        >
                          Report Details
                        </p>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Report Number:
                          </span>{" "}
                          {saleselectedReportNumber}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Report Name:
                          </span>{" "}
                          {saleselectedReportName}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Generated Date &amp; Time:
                          </span>{" "}
                          {saleselectedReportDate}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            KPI Name:{" "}
                          </span>
                          {saleselectedKpiName}
                        </Typography>

                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            KPI Value:{" "}
                            <span style={{ color: "#FCB124" }}>91.52</span>
                          </span>
                        </Typography>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: "5%",
                            marginRight: "5%",
                          }}
                        >
                          <div>
                            <ShareIcon
                              style={{
                                height: "45px",
                                width: "45px",
                                cursor: "pointer",
                                color: "#FCB124",
                              }}
                              onClick={handleGenerateSaleUsers}
                            />
                          </div>
                        </div>
                      </div>
                    </Dialog>

                    <Dialog
                      open={DialogOpenSales}
                      onClose={() => setDialogOpenSalesF(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "250px",
                          height: "100px",
                          overflow: "hidden",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "15%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Mail Sent Successfully
                        </p>
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            color: "#FCB124",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setDialogOpenSales(false)}
                        >
                          <span
                            style={{ fontSize: "20px", fontWeight: "bold" }}
                          >
                            X
                          </span>
                        </button>
                      </div>
                    </Dialog>
                    <Dialog
                      open={DialogOpenSalesF}
                      onClose={() => setDialogOpenSalesF(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "250px",
                          height: "80px",
                          overflow: "hidden",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "15%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          User Mail not exists
                        </p>
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setDialogOpenSalesF(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>
                      </div>
                    </Dialog>

                    <Dialog
                      open={showMailDialog}
                      onClose={() => setShowMailDialog(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "2%",
                          width: "500px",
                          height: "250px",
                          overflow: "hidden",
                        }}
                      >
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowMailDialog(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>

                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "4%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Mail
                        </p>

                        <Autocomplete
                          sx={{ marginTop: "5%", marginLeft: "2%" }}
                          freeSolo
                          value={users}
                          options={salesmail}
                          onSelect={(e) => {
                            setUsers(e.target.value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                              label="To"
                              variant="standard"
                            />
                          )}
                        />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: "18%",
                            marginRight: "5%",
                          }}
                        >
                          <Button
                            variant="contained"
                            className="cancel-button"
                            style={{ width: "100px", marginTop: "25%" }}
                            onClick={handleClearAutocomplete}
                          >
                            Clear
                          </Button>
                          <Button
                            variant="contained"
                            className="save-button"
                            style={{ width: "100px", marginTop: "25%" }}
                            onClick={handleGenerateSalesMail}
                          >
                            Send
                          </Button>
                        </div>
                      </div>
                    </Dialog>
                  </div>
                )}
              </div>

              {lastList ? (
                <div className="small-card-body">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                      width: "100%",
                      alignItems: "center",
                    }}
                  onClick={() => navigate('/my-list', { state: { listName: lastList.listName } })}
                  >
                    <Typography
                      style={{
                        fontWeight: "500",
                        cursor: "pointer",
                        fontSize: "3.2vmin",
                        color: "#666",
                      }}
                    >
                      {lastList.listName}
                    </Typography>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        marginLeft: "10px",
                        fontSize: "3.0vmin",
                        color: "rgb(250, 92, 92)",
                      }}
                    >
                      {lastList.userCount}
                    </Typography>
                  </div>
                </div>
              ):<div className="small-card-body">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: "20px",
                      width: "100%",
                      alignItems: "center",
                    }}
                  onClick={() => navigate('/my-contacts')}
                  >
                    <Typography
                      style={{
                        fontWeight: "500",
                        fontSize: "3.2vmin",
                        color: "#666",
                      }}
                    >
                      Create list
                    </Typography>
                  </div>
                </div>}

              {showPopup && (
                <div className="popup-overlay">
                  <div className="popup-content">
                    <h3>All Lists</h3>
                    {list.map((item) => (
                      <div
                        key={item._id}
                        className="popup-list-item"
                        style={{ marginBottom: "10px", cursor: "pointer", }}
                      >
                        <Typography
                          style={{
                            fontWeight: "bold",
                            fontSize: "2.5vmin",
                          }}
                        >
                          {item.listName? item.listName: <p style={{color:'#000'}}><a href="/my-contacts">Create List</a></p>}
                        </Typography>
                        <Typography style={{ fontSize: "2.5vmin" }}>
                          {item.userCount}
                        </Typography>
                      </div>
                    ))}
                    <Button
                      onClick={() => setShowPopup(false)}
                      style={{ marginTop: "10px" }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}

              {SalemappindData.map((item, index) => (
                <div
                  className="small-card-footer"
                  style={{ marginTop: "35px" }}
                  key={item.Name}
                >
                  {index === 0 && (
                    <p
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        textDecorationColor: "#777675",
                      }}
                      onClick={() => handleOpenchart(item, index)}
                    >
                      Show Lists
                    </p>
                  )}
                </div>
              ))}
            </Card>
            <Card variant="outlined" className="small-card">
              <div className="small-card-head">
                <div className="card-header">
                  <img src={marketing} alt="Ellipse" className="card-icons" />
                  {!marketingsearchopen ? (
                    <span
                      className="card-header-line"
                      style={{ fontWeight: "600" }}
                    >
                      {cardheader.Marketing}
                    </span>
                  ) : null}
                </div>
                {!marketingsearchopen ? (
                  <img
                    onClick={handlemarketingsearch}
                    alt="marketing"
                    src={Searchimg}
                    id="icons"
                    style={{
                      alignItems: "flex-end",
                      marginLeft: "12%",
                      fontSize: "2vmin",
                      height: "17px",
                      cursor: "pointer",
                    }}
                  />
                ) : null}

                {marketingsearchopen ? (
                  // <Search>
                  <Input
                    placeholder="Search here"
                    inputProps={{ "aria-label": "search" }}
                    value={marketingSearchValue}
                    onChange={(e) => {
                      setMarketingSearchValue(e.target.value);
                      // loadCategory(e.target.value, "marketing");
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <CloseIcon
                          onClick={handlemarketingsearch}
                          style={{
                            marginRight: "5px",
                            cursor: "pointer",
                            color: "rgba(0, 0, 0, 0.5)",
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                ) : // </Search>
                null}
                <button
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: "0.5rem",
                    cursor: "pointer",
                    marginLeft: "0.5rem",
                    fontSize: "17px",
                    display: modelMarket ? "none" : "block",
                  }}
                  onClick={handleThreeDotsClickMarket}
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                {isGenerateDropdownVisibleMarket && (
                  <div style={{ position: "relative" }}>
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 5,
                        backgroundColor: "white",
                        border: "1px solid black",
                        padding: "8px",
                        cursor: "pointer",
                        marginTop: "14px",
                        height: "15px",
                        width: "125px",
                        display: modelMarket ? "none" : "block",
                      }}
                      onClick={() => handleOrgActionMarket()}
                    >
                      Generate Report
                    </div>
                    {modelMarket && (
                      <Dialog
                        open={modelMarket}
                        onClose={() => setModelMarket(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "3%",
                            width: "600px",
                            height: "300px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                            }}
                          >
                            Generate Report
                          </p>
                          <Autocomplete
                            sx={{
                              marginTop: "5%",
                              width: "48%",
                              marginLeft: "2%",
                            }}
                            handleHomeEndKeys={false}
                            onSelect={(e) => {
                              console.log("selected");
                            }}
                            open={
                              marketkpiname.length === 0 ||
                              !marketArray.includes(marketkpiname)
                            }
                            openOnFocus={true}
                            autoHighlight={false}
                            autoComplete={true}
                            autoSelect={true}
                            noOptionsText={false}
                            value={marketkpiname}
                            options={marketArray}
                            onInputChange={(event, value) => {
                              if (value.startsWith(value)) {
                                serviceConfig
                                  .get(
                                    "kpi_list",
                                    true,
                                    { category: "marketing", name: value },
                                    null
                                  )
                                  .then((data) => {
                                    setMarketingKPI(data);
                                    const newOptions = data
                                      .filter(
                                        (item) =>
                                          item.category === "marketing" &&
                                          item.kpi_name
                                            .toLowerCase()
                                            .startsWith(value.toLowerCase())
                                      )
                                      .map((item) => item.kpi_name);
                                    setMarketArray(newOptions);
                                  });
                              } else {
                                setMarketArray([]);
                              }

                              setMarketKpiname(value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Enter KPI Name"
                                variant="standard"
                              />
                            )}
                          />
                          {error && (
                            <p style={{ color: "red" }}>KPI name is required</p>
                          )}

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "5%",
                              marginRight: "5%",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="cancel-button"
                              onClick={() => setModelMarket(false)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              className="save-button"
                              style={{ width: "100px" }}
                              onClick={handleGenerateMarketReport}
                            >
                              Generate
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                    )}
                    <Dialog
                      open={showSecondDialog}
                      onClose={() => setShowSecondDialog(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "600px",
                          height: "400px",
                        }}
                      >
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowSecondDialog(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>

                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "4%",
                            fontWeight: "bold",
                            marginLeft: "4%",
                          }}
                        >
                          Report Details
                        </p>

                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Report Number:
                          </span>{" "}
                          {marketselectedReportNumber}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Report Name:
                          </span>{" "}
                          {marketselectedReportName}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Generated Date &amp; Time:
                          </span>{" "}
                          {marketselectedReportDate}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            KPI Name:{" "}
                            <span style={{ color: "#FCB124" }}>
                              {marketselectedKpiName}
                            </span>
                          </span>
                        </Typography>

                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            KPI Value:{" "}
                            <span style={{ color: "#FCB124" }}>91.52</span>
                          </span>
                        </Typography>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: "5%",
                            marginRight: "5%",
                          }}
                        >
                          <div>
                            <ShareIcon
                              style={{
                                height: "45px",
                                width: "45px",
                                cursor: "pointer",
                                color: "#FCB124",
                              }}
                              onClick={handleGenerateMarketUsers}
                            />
                          </div>
                        </div>
                      </div>
                    </Dialog>
                    <Dialog
                      open={DialogOpenMarket}
                      onClose={() => setDialogOpenMarket(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "250px",
                          height: "100px",
                          overflow: "hidden",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "15%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Mail Sent Successfully
                        </p>
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setDialogOpenMarket(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>
                      </div>
                    </Dialog>

                    <Dialog
                      open={DialogOpenMarketF}
                      onClose={() => setDialogOpenMarketF(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "250px",
                          height: "100px",
                          overflow: "hidden",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "15%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          User Mail not exists
                        </p>
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setDialogOpenMarketF(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB123",
                            }}
                          >
                            X
                          </span>
                        </button>
                      </div>
                    </Dialog>
                    <Dialog
                      open={showMailDialog}
                      onClose={() => setShowMailDialog(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "500px",
                          height: "250px",
                          overflow: "hidden",
                        }}
                      >
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowMailDialog(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>

                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "4%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Mail
                        </p>

                        <Autocomplete
                          sx={{ marginTop: "5%", marginLeft: "2%" }}
                          freeSolo
                          value={users}
                          options={marketmail}
                          onSelect={(e) => {
                            console.log(e.target.value);
                            setUsers(e.target.value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                              label="To"
                              variant="standard"
                            />
                          )}
                        />

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: "18%",
                            marginRight: "5%",
                          }}
                        >
                          <Button
                            variant="contained"
                            className="cancel-button"
                            style={{ width: "100px", marginTop: "25%" }}
                            onClick={handleClearAutocomplete}
                          >
                            Clear{" "}
                          </Button>
                          <Button
                            variant="contained"
                            className="save-button"
                            style={{ width: "100px", marginTop: "25%" }}
                            onClick={handleGenerateMarketMail}
                          >
                            Send
                          </Button>
                        </div>
                      </div>
                    </Dialog>
                  </div>
                )}
              </div>
              {userData && (
                <div className="small-card-body">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                      width: "100%",
                      alignItems: "center",
                    }}
                    onClick={() => {
                            if (userData) {
                              navigate("/my-contacts", { state: { checkMyContacts: true } });
                            }
                          }}
                  >
                    <Typography
                      style={{
                        fontWeight: "500",
                        cursor: "pointer",
                        fontSize: "3.2vmin",
                        color: "#666",
                      }}         
                    >
                      My Contacts
                    </Typography>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        marginLeft: "10px",
                        fontSize: "3.0vmin",
                        color: "rgb(250, 92, 92)",
                      }}
                    >
                      {userDataCount}
                    </Typography>
                  </div>
                </div>
              )}

              {userData && (
                <div
                  className="small-card-footer"
                  style={{ marginTop: "25px" }}
                >
                  {SalemappindData.map((item, index) => (
                <div
                  className="small-card-footer"
                  style={{ marginTop: "25px" }}
                  key={item.Name}
                >
                  {index === 0 && (
                    <p
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        textDecorationColor: "#777675",
                      }}
                      onClick={() => handleOpenchartContacts(item, index)}
                    >
                      Show contacts
                    </p>
                  )}
                </div>
              ))}
                </div>
              )}
            </Card>
            <Card variant="outlined" className="small-card">
              <div className="small-card-head">
                <div className="card-header">
                  <img
                    src={customersuccess}
                    alt="Ellipse"
                    className="card-icons"
                  />
                  {!successsearchopen ? (
                    <span
                      className="card-header-line"
                      style={{
                        whiteSpace: "normal",
                        fontWeight: "600",
                        marginLeft: "-4px",
                        ...(max && { whiteSpace: "nowrap" }),
                      }}
                    >
                      {cardheader.Customersuccess}
                    </span>
                  ) : null}
                </div>
                {!successsearchopen ? (
                  <img
                    alt="Search"
                    onClick={handlesuccesssearch}
                    src={Searchimg}
                    id="icons"
                    style={{
                      alignItems: "flex-end",
                      marginLeft: "12%",
                      fontSize: "2vmin",
                      height: "17px",
                      cursor: "pointer",
                    }}
                  />
                ) : null}
                {successsearchopen ? (
                  // <Search>
                  <Input
                    placeholder="Search here"
                    inputProps={{ "aria-label": "search" }}
                    value={successSearchValue}
                    onChange={(e) => {
                      setSuccessSearchValue(e.target.value);
                      // loadCategory(e.target.value, "customer_success");
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <CloseIcon
                          onClick={handlesuccesssearch}
                          style={{
                            marginRight: "5px",
                            cursor: "pointer",
                            color: "rgba(0, 0, 0, 0.5)",
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                ) : // </Search>
                null}
                <button
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: "0.5rem",
                    cursor: "pointer",
                    marginLeft: "0.2rem",
                    fontSize: "17px",
                  }}
                  onClick={handleThreeDotsClickCustomer}
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                {isGenerateDropdownVisibleCustomer && (
                  <div style={{ position: "relative" }}>
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 5,
                        backgroundColor: "white",
                        border: "1px solid black",
                        padding: "8px",
                        cursor: "pointer",
                        marginTop: "14px",
                        height: "15px",
                        width: "125px",
                        display: modelCustomer ? "none" : "block",
                      }}
                      onClick={() => handleOrgActionCustomer()}
                    >
                      Generate Report
                    </div>
                    {modelCustomer && (
                      <Dialog
                        open={modelCustomer}
                        onClose={() => setModelCustomer(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "3%",
                            width: "600px",
                            height: "300px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                            }}
                          >
                            Generate Report
                          </p>

                          <Autocomplete
                            sx={{
                              marginTop: "5%",
                              width: "48%",
                              marginLeft: "2%",
                            }}
                            handleHomeEndKeys={false}
                            onSelect={(e) => {
                              console.log("selected");
                            }}
                            open={
                              customerkpiname.length === 0 ||
                              !customerArray.includes(customerkpiname)
                            }
                            openOnFocus={true}
                            autoHighlight={false}
                            autoComplete={true}
                            autoSelect={true}
                            noOptionsText={false}
                            value={customerkpiname}
                            options={customerArray}
                            onInputChange={(event, value) => {
                              console.log(value);
                              if (value.startsWith(value)) {
                                serviceConfig
                                  .get(
                                    "kpi_list",
                                    true,
                                    {
                                      category: "customer_success",
                                      name: value,
                                    },
                                    null
                                  )
                                  .then((data) => {
                                    setCustomerSuccessKPI(data);
                                    const newOptions = data
                                      .filter(
                                        (item) =>
                                          item.category ===
                                            "customer_success" &&
                                          item.kpi_name
                                            .toLowerCase()
                                            .startsWith(value.toLowerCase())
                                      )
                                      .map((item) => item.kpi_name);
                                    setCustomerArray(newOptions);
                                  });
                              } else {
                                setCustomerArray([]);
                              }

                              setCustomerKpiname(value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Enter KPI Name"
                                variant="standard"
                              />
                            )}
                          />
                          {error && (
                            <p style={{ color: "red" }}>KPI name is required</p>
                          )}

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "5%",
                              marginRight: "5%",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="cancel-button"
                              onClick={() => setModelCustomer(false)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              className="save-button"
                              style={{ width: "100px" }}
                              onClick={handleGenerateCustomerReport}
                            >
                              Generate
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                    )}
                    <Dialog
                      open={showSecondDialog}
                      onClose={() => setShowSecondDialog(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "600px",
                          height: "400px",
                        }}
                      >
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowSecondDialog(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>

                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "4%",
                            fontWeight: "bold",
                            marginLeft: "4%",
                          }}
                        >
                          Report Details
                        </p>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Report Number:
                          </span>{" "}
                          {customerselectedReportNumber}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Report Name:
                          </span>{" "}
                          {customerselectedReportName}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            Generated Date &amp; Time:
                          </span>{" "}
                          {customerselectedReportDate}
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            KPI Name:{" "}
                            <span style={{ color: "#FCB124" }}>
                              {customerselectedKpiName}
                            </span>
                          </span>
                        </Typography>

                        <Typography
                          sx={{ fontFamily: "revert" }}
                          style={{
                            marginBottom: "10px",
                            fontWeight: "light",
                            color: "#FCB124",
                            fontSize: "20px",
                            marginLeft: "4%",
                          }}
                        >
                          <span
                            style={{
                              color: "#333",
                              marginRight: "10px",
                              fontSize: "20px",
                              fontFamily: "revert",
                            }}
                          >
                            KPI Value:{" "}
                            <span style={{ color: "#FCB124" }}>91.52 </span>
                          </span>
                        </Typography>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: "5%",
                            marginRight: "5%",
                          }}
                        >
                          <div>
                            <ShareIcon
                              style={{
                                height: "45px",
                                width: "45px",
                                cursor: "pointer",
                                color: "#FCB124",
                              }}
                              onClick={handleGenerateCustomerUsers}
                            />
                          </div>
                        </div>
                      </div>
                    </Dialog>
                    <Dialog
                      open={DialogOpenCustomer}
                      onClose={() => setDialogOpenCustomer(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "250px",
                          height: "100px",
                          overflow: "hidden",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "15%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Mail Sent Successfully
                        </p>
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setDialogOpenCustomer(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>
                      </div>
                    </Dialog>

                    <Dialog
                      open={DialogOpenCustomerF}
                      onClose={() => setDialogOpenCustomerF(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "250px",
                          height: "100px",
                          overflow: "hidden",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "15%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          User Mail not exists
                        </p>
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setDialogOpenCustomerF(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>
                      </div>
                    </Dialog>
                    <Dialog
                      open={showMailDialog}
                      onClose={() => setShowMailDialog(false)}
                      aria-labelledby="second-dialog-title"
                      aria-describedby="second-dialog-description"
                    >
                      <div
                        style={{
                          backgroundColor: "#F3F3F6",
                          padding: "0%",
                          paddingBottom: "5%",
                          width: "500px",
                          height: "250px",
                          overflow: "hidden",
                        }}
                      >
                        <button
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowMailDialog(false)}
                        >
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "#FCB124",
                            }}
                          >
                            X
                          </span>
                        </button>
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#FCB124",
                            marginTop: "4%",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Mail
                        </p>

                        <Autocomplete
                          sx={{ marginTop: "5%", marginLeft: "2%" }}
                          freeSolo
                          value={users}
                          options={customermail}
                          onSelect={(e) => {
                            console.log(e.target.value);
                            setUsers(e.target.value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              onChange={(e) => {
                                console.log(e.target.value);
                              }}
                              label="To"
                              variant="standard"
                            />
                          )}
                        />

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: "18%",
                            marginRight: "5%",
                          }}
                        >
                          <Button
                            variant="contained"
                            className="cancel-button"
                            style={{ width: "100px", marginTop: "25%" }}
                            onClick={handleClearAutocomplete}
                          >
                            Clear{" "}
                          </Button>
                          <Button
                            variant="contained"
                            className="save-button"
                            style={{ width: "100px", marginTop: "25%" }}
                            onClick={handleGenerateCustomerMail}
                          >
                            Send
                          </Button>
                        </div>
                      </div>
                    </Dialog>
                  </div>
                )}
              </div>
              <div className="small-card-body">
                {latestReminder ? (
                  <div key={latestReminder._id} className="small-card-body">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        marginTop: "20px",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                          }}
                        >
                          {/* <div>
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                toggleTaskCompletion(
                                  reminders.indexOf(latestReminder)
                                )
                              }
                            >
                              {latestReminder.status === "completed" ? (
                                <MdCheckCircle className="checked" />
                              ) : (
                                <MdRadioButtonUnchecked />
                              )}
                            </button>
                          </div> */}
                          <div
                            style={{
                              fontSize: "2.2vmin",
                              fontWeight: "500",
                              marginBottom: "8px",
                              color: "rgb(249, 121, 121)",
                            }}
                          >
                           {latestReminder.companyName}
                          </div>
                        </div>
                        <div
                          style={{
                            fontWeight: "400",
                            cursor: "pointer",
                            fontSize: "1.9vmin",
                            color: "black",
                            marginBottom: "8px",
                            paddingLeft: "20px",
                          }}
                        >
                          {latestReminder.subject}, &nbsp;
                          {new Date(latestReminder.time).toLocaleString(
                            "en-US",
                            {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p style={{ textAlign: "center" }}>No reminders yet.</p>
                )}
              </div>

              {SalemappindData.map((reminder, index) => (
                <div
                  className="small-card-footer"
                  style={{ marginTop: "35px" }}
                  key={reminder._id}
                >
                  {index === 0 && (
                    <p
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        textDecorationColor: "#777675",
                      }}
                      onClick={() => handleOpenchartTask(reminder, index)}
                    >
                      Show Tasks
                    </p>
                  )}
                </div>
              ))}
            </Card>
          </div>

          <div className="mobile-view">
            <Carousel
              selectedItem={activeSlide}
              onChange={handleSlideChange}
              showThumbs={false}
              showStatus={false}
              infiniteLoop
              className="carousal"
            >
              <Card variant="outlined" className="small-card">
                <div className="small-card-head">
                  <div className="card-header">
                    <img src={sales} alt="Ellipse" className="card-icons" />
                    {!salessearchopen ? (
                      <span
                        className="card-header-line"
                        style={{ fontWeight: "400" }}
                      >
                        {" "}
                        {cardheader.Sales}
                      </span>
                    ) : null}
                  </div>
                  {!salessearchopen ? (
                    <img
                      src={Searchimg}
                      id="icons"
                      style={{
                        alignItems: "flex-end",
                        marginLeft: "12%",
                        fontSize: "2vmin",
                        height: "20px",
                        cursor: "pointer",
                      }}
                    />
                  ) : null}
                  {salessearchopen ? (
                    <Search className="card-search">
                      <StyledInputBase2
                        placeholder="Search here"
                        inputProps={{ "aria-label": "search" }}
                        endAdornment={
                          <InputAdornment position="end">
                            <CloseIcon
                              style={{
                                marginRight: "5px",
                                cursor: "pointer",
                                color: "rgba(0, 0, 0, 0.5)",
                              }}
                            />
                          </InputAdornment>
                        }
                      />
                    </Search>
                  ) : null}
                  <button
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      padding: "0.5rem",
                      cursor: "pointer",
                      marginLeft: "2rem",
                      fontSize: "25px",
                    }}
                    onClick={handleThreeDotsClickSales}
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  {isGenerateDropdownVisibleSales && (
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          backgroundColor: "white",
                          border: "1px solid black",
                          padding: "8px",
                          cursor: "pointer",
                          marginTop: "10px",
                          height: "15px",
                          width: "125px",
                          display: modelSale ? "none" : "block",
                        }}
                        onClick={() => handleOrgActionSale()}
                      >
                        Generate Report
                      </div>
                      {modelSale && (
                        <Dialog
                          open={modelSale}
                          onClose={() => setModelSale(false)}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <div
                            style={{
                              backgroundColor: "#F3F3F6",
                              padding: "0%",
                              paddingBottom: "3%",
                              width: "600px",
                              height: "250px",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "16px",
                                marginTop: "4%",
                                fontWeight: "bold",
                                textAlign: "left",
                                color: "#FCB124",
                              }}
                            >
                              Generate Report
                            </p>
                            <Autocomplete
                              sx={{
                                marginTop: "5%",
                                width: "48%",
                                marginLeft: "23%",
                              }}
                              handleHomeEndKeys={false}
                              onSelect={(e) => {
                                console.log("selected");
                              }}
                              open={
                                salekpiname.length === 0 ||
                                !salesArray.includes(salekpiname)
                              }
                              openOnFocus={false}
                              autoHighlight={false}
                              autoComplete={true}
                              autoSelect={true}
                              noOptionsText={false}
                              value={salekpiname}
                              options={salesArray}
                              onInputChange={(event, value) => {
                                console.log(value);
                                if (value.startsWith(value)) {
                                  serviceConfig
                                    .get(
                                      "kpi_list",
                                      true,
                                      { category: "sales", name: value },
                                      null
                                    )
                                    .then((data) => {
                                      setSalesKPI(data);
                                      const newOptions = data
                                        .filter(
                                          (item) =>
                                            item.category === "sales" &&
                                            item.kpi_name
                                              .toLowerCase()
                                              .startsWith(value.toLowerCase())
                                        )
                                        .map((item) => item.kpi_name);
                                      setSalesArray(newOptions);
                                    });
                                } else {
                                  setSalesArray([]);
                                }

                                setSaleKpiname(value);
                              }}
                              renderInput={(params) => (
                                <ThemeProvider theme={theme}>
                                  <TextField
                                    {...params}
                                    label="Enter KPI Name"
                                    variant="standard"
                                    InputProps={{
                                      style: { borderBottomColor: "orange" },
                                      classes: {
                                        underline: "orange-underline",
                                      },
                                    }}
                                  />
                                </ThemeProvider>
                              )}
                            />

                            {error && (
                              <p style={{ color: "red" }}>
                                KPI name is required
                              </p>
                            )}

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "5%",
                                marginLeft: "35%",
                              }}
                            >
                              <Button
                                variant="contained"
                                className="cancel-button"
                                onClick={() => setModelSale(false)}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="contained"
                                className="save-button"
                                style={{ width: "100px" }}
                                onClick={handleGenerateSalesReport}
                              >
                                Generate
                              </Button>
                            </div>
                          </div>
                        </Dialog>
                      )}
                      <Dialog
                        open={showSecondDialog}
                        onClose={() => setShowSecondDialog(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "600px",
                            height: "400px",
                          }}
                        >
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowSecondDialog(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>

                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                              marginLeft: "4%",
                            }}
                          >
                            Report Details
                          </p>
                          {/* <Typography sx={{fontFamily:"revert"}}  style={{ marginBottom: '10px', fontWeight: 'light', color: '#167aad' , fontSize: '20px',marginLeft:'4%'}}>
      <span style={{ color: '#333', marginRight: '10px', fontSize: '20px' ,fontFamily:"revert"}}>Report Id:</span> {saleselectedReportId}
    </Typography> */}
                          {/* <Typography sx={{fontFamily:"revert"}}  style={{ marginBottom: '10px', fontWeight: 'light', color: '#167aad' , fontSize: '20px',marginLeft:'4%'}}>
      <span style={{ color: '#333', marginRight: '10px', fontSize: '20px' ,fontFamily:"revert"}}>Report No:</span> {saleselectedReportNo}
    </Typography> */}
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Report Number:
                            </span>{" "}
                            {saleselectedReportNumber}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Report Name:
                            </span>{" "}
                            {saleselectedReportName}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Generated Date &amp; Time:
                            </span>{" "}
                            {saleselectedReportDate}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              KPI Name:{" "}
                            </span>
                            {saleselectedKpiName}
                          </Typography>

                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              KPI Value:{" "}
                              <span style={{ color: "#FCB124" }}>91.52</span>
                            </span>
                          </Typography>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "5%",
                              marginRight: "5%",
                            }}
                          >
                            {/* <Button variant="contained" className='save-button' style={{width:"100px"}} onClick={handleGenerateSaleUsers}>SHARE</Button> */}
                            {/* <img src={ShareIcon} alt="share" style={{height:"45px", width: "45px", cursor: "pointer",marginTop:"-90%",color:'#FCB124'}} onClick={handleGenerateSaleUsers}/> */}
                            <div>
                              <ShareIcon
                                style={{
                                  height: "45px",
                                  width: "45px",
                                  cursor: "pointer",
                                  color: "#FCB124",
                                }}
                                onClick={handleGenerateSaleUsers}
                              />
                            </div>
                          </div>
                        </div>
                      </Dialog>

                      <Dialog
                        open={DialogOpenSales}
                        onClose={() => setDialogOpenSalesF(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "250px",
                            height: "100px",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "15%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            Mail Sent Successfully
                          </p>

                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              color: "#FCB124",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setDialogOpenSales(false)}
                          >
                            <span
                              style={{ fontSize: "20px", fontWeight: "bold" }}
                            >
                              X
                            </span>
                          </button>
                        </div>
                      </Dialog>

                      <Dialog
                        open={DialogOpenSalesF}
                        onClose={() => setDialogOpenSalesF(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "250px",
                            height: "80px",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "15%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            User Mail not exists
                          </p>
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setDialogOpenSalesF(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>
                        </div>
                      </Dialog>

                      <Dialog
                        open={showMailDialog}
                        onClose={() => setShowMailDialog(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "2%",
                            width: "500px",
                            height: "250px",
                            overflow: "hidden",
                          }}
                        >
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowMailDialog(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>

                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            Mail
                          </p>

                          <Autocomplete
                            sx={{ marginTop: "5%", marginLeft: "2%" }}
                            freeSolo
                            value={users}
                            options={salesmail}
                            onSelect={(e) => {
                              setUsers(e.target.value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onChange={(e) => {
                                  console.log(e.target.value);

                                  // setSaleKpiname(e.target.value
                                  //     )
                                }}
                                label="To"
                                variant="standard"
                              />
                            )}
                          />

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "18%",
                              marginRight: "5%",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="cancel-button"
                              style={{ width: "100px", marginTop: "25%" }}
                              onClick={handleClearAutocomplete}
                            >
                              Clear
                            </Button>
                            <Button
                              variant="contained"
                              className="save-button"
                              style={{ width: "100px", marginTop: "25%" }}
                              onClick={handleGenerateSalesMail}
                            >
                              Send
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                    </div>
                  )}
                </div>
                <div className="small-card-body">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "95%",
                      textAlign: "left",
                    }}
                  >
                    <Typography
                      style={{
                        marginLeft: "10px",
                        fontWeight: "bold",
                        fontSize: "5vmin",
                        lineHeight: "5vmin",
                      }}
                    >
                      91.02
                    </Typography>
                    <Typography
                      style={{
                        marginRight: "10px",
                        marginLeft: "20%",
                        color: "#00C814",
                        fontWeight: "bold",
                        fontSize: "4.4vmin",
                        lineHeight: "4.4vmin",
                      }}
                    >
                      +1.5{" "}
                      <span>
                        <NorthIcon style={{ fontSize: "4.5vmin" }} />
                      </span>
                    </Typography>
                  </div>
                  <p className="small-card-body-line">
                    Projected Pipeline Sales Value
                  </p>
                </div>
                <div className="small-card-footer">
                  {/* <p style={{ cursor: 'pointer' }}>VIEW CHART</p> */}
                </div>
              </Card>
              <Card variant="outlined" className="small-card">
                <div className="small-card-head">
                  <div className="card-header">
                    <img src={marketing} alt="Ellipse" className="card-icons" />
                    {!marketingsearchopen ? (
                      <span
                        className="card-header-line"
                        style={{ fontWeight: "400" }}
                      >
                        {cardheader.Marketing}
                      </span>
                    ) : null}
                  </div>
                  {!marketingsearchopen ? (
                    <img
                      onClick={handlemarketingsearch}
                      src={Searchimg}
                      id="icons"
                      style={{
                        alignItems: "flex-end",
                        marginLeft: "12%",
                        fontSize: "2vmin",
                        height: "25px",
                        cursor: "pointer",
                      }}
                    />
                  ) : null}

                  {marketingsearchopen ? (
                    <Search>
                      <StyledInputBase2
                        placeholder="Search here"
                        inputProps={{ "aria-label": "search" }}
                        value={marketingSearchValue}
                        onChange={(e) => {
                          setMarketingSearchValue(e.target.value);
                          // loadCategory(e.target.value, "marketing");
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <CloseIcon
                              onClick={handlemarketingsearch}
                              style={{
                                marginRight: "5px",
                                cursor: "pointer",
                                color: "rgba(0, 0, 0, 0.5)",
                              }}
                            />
                          </InputAdornment>
                        }
                      />
                    </Search>
                  ) : null}
                  <button
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      padding: "0.5rem",
                      cursor: "pointer",
                      marginLeft: "1rem",
                      fontSize: "25px",
                      display: modelMarket ? "none" : "block",
                    }}
                    onClick={handleThreeDotsClickMarket}
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  {isGenerateDropdownVisibleMarket && (
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 5,
                          backgroundColor: "white",
                          border: "1px solid black",
                          padding: "8px",
                          cursor: "pointer",
                          marginTop: "14px",
                          height: "15px",
                          width: "125px",
                        }}
                        onClick={() => handleOrgActionMarket()}
                      >
                        Generate Report
                      </div>
                      {modelMarket && (
                        <Dialog
                          open={modelMarket}
                          onClose={() => setModelMarket(false)}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <div
                            style={{
                              backgroundColor: "#F3F3F6",
                              padding: "0%",
                              paddingBottom: "3%",
                              width: "600px",
                              height: "300px",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "16px",
                                color: "#FCB124",
                                marginTop: "4%",
                                fontWeight: "bold",
                                textAlign: "left",
                              }}
                            >
                              Generate Report
                            </p>

                            {/* <TextField InputProps={{ sx: { height: 50 } }} sx={{
                        width: '48.5%', alignSelf: 'center', marginTop: '0%',marginLeft:'2%', "&  label.Mui-focused": { color: '#2A4D69', fontSize: '20px', fontWeight: 'bold' }
                    }} label="Report Name" variant="standard"  onChange={e => setMarketReportname(e.target.value)} value={marketreportname}/>
                
                    <TextField InputProps={{ sx: { height: 50 } }} sx={{
                        width: '45%', alignSelf: 'center', marginTop: '0%', marginLeft:'2%', "&  label.Mui-focused": { color: '#2A4D69', fontSize: '20px', fontWeight: 'bold' }
                    }} label="KPI value" variant="standard"   onChange={e => setMarketKpivalue(e.target.value)}value={marketkpivalue} /> */}

                            <Autocomplete
                              sx={{
                                marginTop: "5%",
                                width: "48%",
                                marginLeft: "2%",
                              }}
                              handleHomeEndKeys={false}
                              onSelect={(e) => {
                                console.log("selected");
                              }}
                              open={
                                marketkpiname.length === 0 ||
                                !marketArray.includes(marketkpiname)
                              }
                              openOnFocus={true}
                              autoHighlight={false}
                              autoComplete={true}
                              autoSelect={true}
                              noOptionsText={false}
                              value={marketkpiname}
                              options={marketArray}
                              onInputChange={(event, value) => {
                                console.log(value);
                                if (value.startsWith(value)) {
                                  serviceConfig
                                    .get(
                                      "kpi_list",
                                      true,
                                      { category: "marketing", name: value },
                                      null
                                    )
                                    .then((data) => {
                                      setMarketingKPI(data);
                                      const newOptions = data
                                        .filter(
                                          (item) =>
                                            item.category === "marketing" &&
                                            item.kpi_name
                                              .toLowerCase()
                                              .startsWith(value.toLowerCase())
                                        )
                                        .map((item) => item.kpi_name);
                                      setMarketArray(newOptions);
                                    });
                                  // .catch((err) => {
                                  //   console.log(err);
                                  // });
                                } else {
                                  setMarketArray([]);
                                }

                                setMarketKpiname(value);
                              }}
                              renderInput={(params) => (
                                <ThemeProvider theme={theme}>
                                  <TextField
                                    {...params}
                                    label="Enter KPI Name"
                                    variant="standard"
                                    InputProps={{
                                      style: { borderBottomColor: "orange" },
                                      classes: {
                                        underline: "orange-underline",
                                      },
                                    }}
                                  />
                                </ThemeProvider>
                              )}
                            />
                            {error && (
                              <p style={{ color: "red" }}>
                                KPI name is required
                              </p>
                            )}

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                marginTop: "5%",
                                marginRight: "5%",
                              }}
                            >
                              <Button
                                variant="contained"
                                className="cancel-button"
                                onClick={() => setModelMarket(false)}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="contained"
                                className="save-button"
                                style={{ width: "100px" }}
                                onClick={handleGenerateMarketReport}
                              >
                                Generate
                              </Button>
                            </div>
                          </div>
                        </Dialog>
                      )}
                      <Dialog
                        open={showSecondDialog}
                        onClose={() => setShowSecondDialog(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "600px",
                            height: "400px",
                          }}
                        >
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowSecondDialog(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>

                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                              marginLeft: "4%",
                            }}
                          >
                            Report Details
                          </p>
                          {/* <Typography sx={{fontFamily:"revert"}}  style={{ marginBottom: '10px', fontWeight: 'light', color: '#167aad' , fontSize: '20px',marginLeft:'4%'}}>
      <span style={{ color: '#333', marginRight: '10px', fontSize: '20px' ,fontFamily:"revert"}}>Report Id:</span> {marketselectedReportId}
    </Typography>
    <Typography sx={{fontFamily:"revert"}}  style={{ marginBottom: '10px', fontWeight: 'light', color: '#167aad' , fontSize: '20px',marginLeft:'4%'}}>
      <span style={{ color: '#333', marginRight: '10px', fontSize: '20px' ,fontFamily:"revert"}}>Report No:</span> {marketselectedReportNo}
    </Typography> */}
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Report Number:
                            </span>{" "}
                            {marketselectedReportNumber}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Report Name:
                            </span>{" "}
                            {marketselectedReportName}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Generated Date &amp; Time:
                            </span>{" "}
                            {marketselectedReportDate}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              KPI Name:{" "}
                              <span style={{ color: "#FCB124" }}>
                                {marketselectedKpiName}
                              </span>
                            </span>
                          </Typography>

                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              KPI Value:{" "}
                              <span style={{ color: "#FCB124" }}>91.52</span>
                            </span>
                          </Typography>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "5%",
                              marginRight: "5%",
                            }}
                          >
                            {/* <img src={shareiconimg} alt="share" style={{height:"45px", width: "45px", cursor: "pointer",marginTop:"-70%"}}onClick={handleGenerateMarketUsers}></img> */}
                            <div>
                              <ShareIcon
                                style={{
                                  height: "45px",
                                  width: "45px",
                                  cursor: "pointer",
                                  color: "#FCB124",
                                }}
                                onClick={handleGenerateMarketUsers}
                              />
                            </div>
                          </div>
                        </div>
                      </Dialog>
                      <Dialog
                        open={DialogOpenMarket}
                        onClose={() => setDialogOpenMarket(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "250px",
                            height: "100px",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "15%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            Mail Sent Successfully
                          </p>
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setDialogOpenMarket(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>
                        </div>
                      </Dialog>

                      <Dialog
                        open={DialogOpenMarketF}
                        onClose={() => setDialogOpenMarketF(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "250px",
                            height: "100px",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "15%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            User Mail not exists
                          </p>
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setDialogOpenMarketF(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB123",
                              }}
                            >
                              X
                            </span>
                          </button>
                        </div>
                      </Dialog>
                      <Dialog
                        open={showMailDialog}
                        onClose={() => setShowMailDialog(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "500px",
                            height: "250px",
                            overflow: "hidden",
                          }}
                        >
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowMailDialog(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>

                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            Mail
                          </p>

                          <Autocomplete
                            sx={{ marginTop: "5%", marginLeft: "2%" }}
                            freeSolo
                            value={users}
                            options={marketmail}
                            onSelect={(e) => {
                              console.log(e.target.value);
                              setUsers(e.target.value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onChange={(e) => {
                                  console.log(e.target.value);

                                  // setSaleKpiname(e.target.value
                                  //     )
                                }}
                                label="To"
                                variant="standard"
                              />
                            )}
                          />

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "18%",
                              marginRight: "5%",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="cancel-button"
                              style={{ width: "100px", marginTop: "25%" }}
                              onClick={handleClearAutocomplete}
                            >
                              Clear{" "}
                            </Button>
                            <Button
                              variant="contained"
                              className="save-button"
                              style={{ width: "100px", marginTop: "25%" }}
                              onClick={handleGenerateMarketMail}
                            >
                              Send
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                    </div>
                  )}
                </div>
                <div className="small-card-body">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "95%",
                      textAlign: "left",
                    }}
                  >
                    <Typography
                      style={{
                        marginLeft: "10px",
                        fontWeight: "bold",
                        fontSize: "5vmin",
                        lineHeight: "5vmin",
                      }}
                    >
                      91.02
                    </Typography>
                    <Typography
                      style={{
                        marginRight: "10px",
                        marginLeft: "20%",
                        color: "#00C814",
                        fontWeight: "bold",
                        fontSize: "4.4vmin",
                        lineHeight: "4.4vmin",
                      }}
                    >
                      +1.5{" "}
                      <span>
                        <NorthIcon style={{ fontSize: "4.5vmin" }} />
                      </span>
                    </Typography>
                  </div>
                  <p className="small-card-body-line">Customer Health Score</p>
                </div>
                <div className="small-card-footer">
                  {/* <p style={{ cursor: 'pointer' }}>VIEW CHART</p> */}
                </div>
              </Card>
              <Card variant="outlined" className="small-card">
                <div className="small-card-head">
                  <div className="card-header">
                    <img
                      src={customersuccess}
                      alt="Ellipse"
                      className="card-icons"
                    />
                    {!successsearchopen ? (
                      <span
                        className="card-header-line"
                        style={{ fontWeight: "400" }}
                      >
                        {cardheader.Customersuccess}
                      </span>
                    ) : null}
                  </div>
                  {!successsearchopen ? (
                    <img
                      onClick={handlesuccesssearch}
                      src={Searchimg}
                      id="icons"
                      style={{
                        alignItems: "flex-end",
                        marginLeft: "12%",
                        fontSize: "2vmin",
                        height: "25px",
                        cursor: "pointer",
                      }}
                    />
                  ) : null}
                  {successsearchopen ? (
                    <Search>
                      <StyledInputBase2
                        placeholder="Search here"
                        inputProps={{ "aria-label": "search" }}
                        endAdornment={
                          <InputAdornment position="end">
                            <CloseIcon
                              onClick={handlesuccesssearch}
                              style={{
                                marginRight: "5px",
                                cursor: "pointer",
                                color: "rgba(0, 0, 0, 0.5)",
                              }}
                            />
                          </InputAdornment>
                        }
                      />
                    </Search>
                  ) : null}
                  <button
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      padding: "0.5rem",
                      cursor: "pointer",
                      marginLeft: "2rem",
                      fontSize: "25px",
                    }}
                    onClick={handleThreeDotsClickCustomer}
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  {isGenerateDropdownVisibleCustomer && (
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 5,
                          backgroundColor: "white",
                          border: "1px solid black",
                          padding: "8px",
                          cursor: "pointer",
                          marginTop: "14px",
                          height: "15px",
                          width: "125px",
                        }}
                        onClick={() => handleOrgActionCustomer()}
                      >
                        Generate Report
                      </div>
                      <Dialog
                        open={modelCustomer}
                        onClose={() => setModelCustomer(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "3%",
                            width: "600px",
                            height: "300px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            Generate Report
                          </p>

                          {/* <TextField InputProps={{ sx: { height: 50 } }} sx={{
                        width: '48.5%', alignSelf: 'center', marginTop: '0%',marginLeft:'2%', "&  label.Mui-focused": { color: '#2A4D69', fontSize: '20px', fontWeight: 'bold' }
                    }} label="Report Name" variant="standard"  onChange={e => setCustomerReportname(e.target.value)} value={customerreportname}/>
                   
                    <TextField InputProps={{ sx: { height: 50 } }} sx={{
                        width: '45%', alignSelf: 'center', marginTop: '0%', marginLeft:'2%', "&  label.Mui-focused": { color: '#2A4D69', fontSize: '20px', fontWeight: 'bold' }
                    }} label="KPI value" variant="standard"   onChange={e => setCustomerKpivalue(e.target.value)}value={customerkpivalue} /> */}

                          <Autocomplete
                            sx={{
                              marginTop: "5%",
                              width: "48%",
                              marginLeft: "2%",
                            }}
                            handleHomeEndKeys={false}
                            onSelect={(e) => {
                              console.log("selected");
                            }}
                            open={
                              customerkpiname.length === 0 ||
                              !customerArray.includes(customerkpiname)
                            }
                            openOnFocus={true}
                            autoHighlight={false}
                            autoComplete={true}
                            autoSelect={true}
                            noOptionsText={false}
                            value={customerkpiname}
                            options={customerArray}
                            onInputChange={(event, value) => {
                              console.log(value);
                              if (value.startsWith(value)) {
                                serviceConfig
                                  .get(
                                    "kpi_list",
                                    true,
                                    {
                                      category: "customer_success",
                                      name: value,
                                    },
                                    null
                                  )
                                  .then((data) => {
                                    setCustomerSuccessKPI(data);
                                    const newOptions = data
                                      .filter(
                                        (item) =>
                                          item.category ===
                                            "customer_success" &&
                                          item.kpi_name
                                            .toLowerCase()
                                            .startsWith(value.toLowerCase())
                                      )
                                      .map((item) => item.kpi_name);
                                    setCustomerArray(newOptions);
                                  });
                                // .catch((err) => {
                                //   console.log(err);
                                // });
                              } else {
                                setCustomerArray([]);
                              }

                              setCustomerKpiname(value);
                            }}
                            renderInput={(params) => (
                              <ThemeProvider theme={theme}>
                                <TextField
                                  {...params}
                                  label="Enter KPI Name"
                                  variant="standard"
                                  InputProps={{
                                    style: { borderBottomColor: "orange" },
                                    classes: { underline: "orange-underline" },
                                  }}
                                />
                              </ThemeProvider>
                            )}
                          />
                          {error && (
                            <p style={{ color: "red" }}>KPI name is required</p>
                          )}

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "5%",
                              marginRight: "5%",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="cancel-button"
                              onClick={() => setModelCustomer(false)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              className="save-button"
                              style={{ width: "100px" }}
                              onClick={handleGenerateCustomerReport}
                            >
                              Generate
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                      <Dialog
                        open={showSecondDialog}
                        onClose={() => setShowSecondDialog(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "600px",
                            height: "400px",
                          }}
                        >
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowSecondDialog(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>

                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                              marginLeft: "4%",
                            }}
                          >
                            Report Details
                          </p>
                          {/* <Typography sx={{fontFamily:"revert"}}  style={{ marginBottom: '10px', fontWeight: 'light', color: '#167aad' , fontSize: '20px',marginLeft:'4%'}}>
      <span style={{ color: '#333', marginRight: '10px', fontSize: '20px' ,fontFamily:"revert"}}>Report Id:</span> {customerselectedReportId}
    </Typography>
    <Typography sx={{fontFamily:"revert"}}  style={{ marginBottom: '10px', fontWeight: 'light', color: '#167aad' , fontSize: '20px',marginLeft:'4%'}}>
      <span style={{ color: '#333', marginRight: '10px', fontSize: '20px' ,fontFamily:"revert",}}>Report No:</span> {customerselectedReportNo}
    </Typography> */}
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Report Number:
                            </span>{" "}
                            {customerselectedReportNumber}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Report Name:
                            </span>{" "}
                            {customerselectedReportName}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              Generated Date &amp; Time:
                            </span>{" "}
                            {customerselectedReportDate}
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              KPI Name:{" "}
                              <span style={{ color: "#FCB124" }}>
                                {customerselectedKpiName}
                              </span>
                            </span>
                          </Typography>

                          <Typography
                            sx={{ fontFamily: "revert" }}
                            style={{
                              marginBottom: "10px",
                              fontWeight: "light",
                              color: "#FCB124",
                              fontSize: "20px",
                              marginLeft: "4%",
                            }}
                          >
                            <span
                              style={{
                                color: "#333",
                                marginRight: "10px",
                                fontSize: "20px",
                                fontFamily: "revert",
                              }}
                            >
                              KPI Value:{" "}
                              <span style={{ color: "#FCB124" }}>91.52 </span>
                            </span>
                          </Typography>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "5%",
                              marginRight: "5%",
                            }}
                          >
                            {/* <Button variant="contained"  className='save-button' style={{width:"100px"}}  >SHARE</Button> */}
                            {/* <img src={shareiconimg} alt="share" style={{height:"45px", width: "45px", cursor: "pointer",marginTop:"-70%"}} onClick={handleGenerateCustomerUsers}></img> */}
                            <div>
                              <ShareIcon
                                style={{
                                  height: "45px",
                                  width: "45px",
                                  cursor: "pointer",
                                  color: "#FCB124",
                                }}
                                onClick={handleGenerateCustomerUsers}
                              />
                            </div>
                          </div>
                        </div>
                      </Dialog>
                      <Dialog
                        open={DialogOpenCustomer}
                        onClose={() => setDialogOpenCustomer(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "250px",
                            height: "100px",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "15%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            Mail Sent Successfully
                          </p>
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setDialogOpenCustomer(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>
                        </div>
                      </Dialog>

                      <Dialog
                        open={DialogOpenCustomerF}
                        onClose={() => setDialogOpenCustomerF(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "250px",
                            height: "100px",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "15%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            User Mail not exists
                          </p>
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setDialogOpenCustomerF(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>
                        </div>
                      </Dialog>
                      <Dialog
                        open={showMailDialog}
                        onClose={() => setShowMailDialog(false)}
                        aria-labelledby="second-dialog-title"
                        aria-describedby="second-dialog-description"
                      >
                        <div
                          style={{
                            backgroundColor: "#F3F3F6",
                            padding: "0%",
                            paddingBottom: "5%",
                            width: "500px",
                            height: "250px",
                            overflow: "hidden",
                          }}
                        >
                          <button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowMailDialog(false)}
                          >
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#FCB124",
                              }}
                            >
                              X
                            </span>
                          </button>
                          <p
                            style={{
                              fontSize: "16px",
                              color: "#FCB124",
                              marginTop: "4%",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            Mail
                          </p>

                          <Autocomplete
                            sx={{ marginTop: "5%", marginLeft: "2%" }}
                            freeSolo
                            value={users}
                            options={customermail}
                            onSelect={(e) => {
                              console.log(e.target.value);
                              setUsers(e.target.value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onChange={(e) => {
                                  console.log(e.target.value);

                                  // setSaleKpiname(e.target.value
                                  //     )
                                }}
                                label="To"
                                variant="standard"
                              />
                            )}
                          />

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              marginTop: "18%",
                              marginRight: "5%",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="cancel-button"
                              style={{ width: "100px", marginTop: "25%" }}
                              onClick={handleClearAutocomplete}
                            >
                              Clear{" "}
                            </Button>
                            <Button
                              variant="contained"
                              className="save-button"
                              style={{ width: "100px", marginTop: "25%" }}
                              onClick={handleGenerateCustomerMail}
                            >
                              Send
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                    </div>
                  )}
                </div>
                <div className="small-card-body">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "95%",
                      textAlign: "left",
                    }}
                  >
                    <Typography
                      style={{
                        marginLeft: "10px",
                        fontWeight: "bold",
                        fontSize: "5vmin",
                        lineHeight: "5vmin",
                      }}
                    >
                      91.02
                    </Typography>
                    <Typography
                      style={{
                        marginRight: "10px",
                        marginLeft: "20%",
                        color: "#00C814",
                        fontWeight: "bold",
                        fontSize: "4.4vmin",
                        lineHeight: "4.4vmin",
                      }}
                    >
                      +1.5{" "}
                      <span>
                        <NorthIcon style={{ fontSize: "4.5vmin" }} />
                      </span>
                    </Typography>
                  </div>
                  <p className="small-card-body-line">
                    Projected Pipeline Sales Value
                  </p>
                </div>
                <div className="small-card-footer">
                  {/* <p style={{ cursor: 'pointer' }} >VIEW CHART</p> */}
                </div>
              </Card>
            </Carousel>
          </div>
        </div>

        <div id="second-container">
          <div id="highlights" >
            <div className="small-card-head">
              <div
                style={{
                  width: "70%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: "5%",
                  gap: "5px",
                  cursor:'pointer'
                }}
              >
                    <img src={contacts} alt="Ellipse" className="card-icons" />
                {!kpisearchopen ? (
                  <span
                    className="card-header-line"
                    style={{ fontWeight: "400" }}
                    onClick={() => navigate('/contacts', { state: { checkContacts: true } })}
                  >
                    Contacts
                  </span>
                ) : null}
              </div>
              {!kpisearchopen ? (
                <img
                  alt="kpi"
                  onClick={handlekpisearch}
                  src={Searchimg}
                  id="icons"
                  style={{
                    alignItems: "flex-end",
                    marginLeft: "12%",
                    fontSize: "2vmin",
                    height: "25px",
                    marginBottom: "5%",
                    marginTop: "4%",
                  }}
                />
              ) : null}
              {kpisearchopen ? (
                <KPISearch
                  setSearchData={setSearchData}
                  searchList={searchUser}
                >
                  <InputAdornment position="end">
                    <CloseIcon
                      onClick={handlekpisearch}
                      style={{
                        marginRight: "5px",
                        cursor: "pointer",
                        color: "rgba(0, 0, 0, 0.5)",
                      }}
                    />
                  </InputAdornment>
                </KPISearch>
              ) : null}
              <IconButton
                onClick={handleClick}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MoreVertIcon
                  className="three-dot-icon"
                  style={{
                    fontSize: "4vmin",
                    color: "rgba(29, 4, 4, 0.57)",
                    cursor: "pointer",
                  }}
                />
              </IconButton>
              {/* <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                {/* // <MenuItem  onClick={() => handleOrgAction()}>
              
                //</MenuItem>

              </Menu> */}
            </div>
            <TableContainer
              className="table-wrap"
              style={{ overflowY: "auto", cursor: "default" }}
              ref={divRef}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <Table
                stickyHeader
                className="table-container"
                aria-label="simple table"
                style={{ minWidth: "350px" }}
              >
                <TableHead className="table-head">
                  <TableRow className="table-row">
                    <TableCell className="table-cell" align="left">
                      Name
                    </TableCell>
                    <TableCell className="table-cell" align="left">
                      Company name
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="table-body">
                  {data.map((item) => (
                    <TableRow
                      key={item.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        component="th"
                        align="left"
                        scope="row"
                        style={{
                          color: "rgba(0, 0, 0, 0.69)",
                          fontSize: "12px",
                          width: '120px'
                        }}
                      >
                        {item.firstname}
                      </TableCell>

                      <TableCell
                        className="table-contend"
                        align="left"
                        style={{
                          color: "rgba(0, 0, 0, 0.69)",
                          fontSize: "12px",
                        }}
                      >
                        {item.companyname}
                      </TableCell>
                      {/* <TableCell align="right">
                        {item.category === 'sales' && (
                          <Typography className="table-contend" style={{ color: '#6ADA7D' }}>
                            +91.09
                            <span className='table-contend-arrow' style={{ fontSize: '2.5vmin' }}>&#8593;</span>
                          </Typography>
                        )}
                        {item.category === 'marketing' && (
                          <Typography className="table-contend" style={{ color: '#6ADA7D' }}>
                            +81.85
                            <span className='table-contend-arrow' style={{ fontSize: '2.5vmin' }}>&#8593;</span>
                          </Typography>
                        )}
                        {item.category === 'customer_success' && (
                          <Typography className="table-contend" style={{ color: '#6ADA7D' }}>
                            +11.09
                            <span className='table-contend-arrow' style={{ fontSize: '2.5vmin' }}>&#8593;</span>
                          </Typography>
                        )}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div id="performance">
            <div className="small-card-head">
              <div
                style={{
                  width: "70%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: "3%",
                  gap: "10px",
                }}
              >
                <span
                  className="card-header-line"
                  style={{ fontWeight: "600" }}
                >
                  Inside Scoops
                </span>
              </div>
            </div>

            <div className="scoops-table">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Company</th>
                    <th>Technology</th>
                    <th>Jobs</th>
                    <th>News</th>
                  </tr>
                </thead>
                <tbody>
                  {userData.map((user, index) => (
                    <tr key={index}>
                      <td>
                        {user.updatedAt
                          ? new Date(user.updatedAt).toLocaleDateString()
                          : "N/A"}
                      </td>

                      <td style={{ color: "#0073e6", textAlign: "center" }}>
                        <div className="company-info">
                          {user.companyname || "N/A"}
                          <br />
                          <span>{user.country || "N/A"}</span>
                        </div>
                      </td>

                      <td style={{ textAlign: "center" }}>
                        <div className="company-info">
                          {truncateWords(user.technologydetails)}
                        </div>
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {user.jobopenings && user.jobopenings.length > 0
                          ? truncateWords(
                              user.jobopenings
                                .map((job) => job.jobname || job.jobdescription)
                                .join(" ")
                            )
                          : "Not Available"}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {user.newsandsocialinsights &&
                        user.newsandsocialinsights.length > 0
                          ? truncateWords(
                              user.newsandsocialinsights
                                .map(
                                  (news) =>
                                    news.newsname || news.newsdescription
                                )
                                .join(" ")
                            )
                          : "Not Available"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
